import React, { useState, useRef, useEffect } from "react";
import "./modelDropDown.css";

const YearDropDown = ({ selectedYear, setSelectedYear, availableYears = [], translate, disabled = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const placeholder = translate ? translate("Select Year") : "Select Year";

  const handleSelect = (value) => {
    setSelectedYear(value);
    setIsOpen(false);
  };

  const getSelectedLabel = () => {
    return selectedYear ? selectedYear : placeholder;
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="model-dropdown-container">
      <span className="model-dropdown-label">
        {translate ? translate("Year") : "Year"}
      </span>
      <div className="model-dropdown-inner" ref={dropdownRef}>
        <div
          className={`model-dropdown ${disabled ? "disabled" : ""}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          {getSelectedLabel()}
        </div>
        {isOpen && !disabled && (
          <div className="model-dropdown-options">
            <div className="model-dropdown-option placeholder">
              {placeholder}
            </div>
            {availableYears.map((year) => (
              <div
                key={year}
                className="model-dropdown-option"
                onClick={() => handleSelect(year)}
              >
                {year}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default YearDropDown;
